import React from 'react';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import FrequentlyAskedQuestions from '@/components/shared/FrequentlyAskedQuestions';
import ProvenResults from '@/components/shared/ProvenResults';
import SEO from '@/components/shared/SEO';

const FAQ = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How does the AI interviewer work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our AI interviewer uses advanced natural language processing to conduct realistic interviews. Candidates can talk to our AI directly in their browser or request a call back at their convenience. They answer role-specific questions while the AI adapts based on their responses, asking follow-up questions to thoroughly assess each skill area. After the interview, you receive detailed analysis including skill scores, candidate summaries, and recommended next steps."
        }
      },
      {
        "@type": "Question",
        "name": "What types of roles can RoundOne screen for?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RoundOne AI can screen for virtually any role across industries. Whether you're hiring C-suite executives or warehouse staff, healthcare professionals or creative designers, our platform adapts to evaluate the specific skills needed for success. From highly specialized roles requiring technical expertise to customer-facing positions demanding exceptional soft skills, our customizable assessments provide consistent, data-driven evaluations for any position in your organization."
        }
      },
      {
        "@type": "Question",
        "name": "How long does implementation take?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can be up and running with RoundOne in minutes. Creating your first assessment takes as little as 5 minutes, and you can send candidate invitations immediately after. For ATS integration, our two-click setup process typically takes less than 15 minutes. We also offer white-glove implementation support for Enterprise plans to assist with custom workflows and configurations."
        }
      },
      {
        "@type": "Question",
        "name": "How do candidates feel about AI interviews?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our candidate satisfaction rate is over 92%. Candidates appreciate the flexibility to complete interviews on their own schedule, the consistent and fair evaluation process, and the natural conversation flow with our AI. We've designed the experience to be engaging and professional, and many candidates report preferring it to traditional screening calls that often feel rushed or impersonal."
        }
      },
      {
        "@type": "Question",
        "name": "How accurate are the AI assessments?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our assessments achieve 88% accuracy compared to expert human evaluations. We're constantly training and refining our AI with input from industry experts across various domains. Our AI evaluates both the technical accuracy of responses and important nuances like problem-solving approach, communication clarity, and depth of knowledge. Each assessment includes confidence scores so you can easily identify areas that may benefit from additional evaluation."
        }
      }
    ]
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEO 
        title="Frequently Asked Questions"
        description="Get answers to common questions about RoundOne AI's candidate assessment platform, features, pricing, and how it can transform your hiring process."
        schema={faqSchema}
      />
      {/* Use the shared Header component */}
      <Header />
      
      {/* Main content */}
      <main className="flex-1">
        {/* Hero section */}
        <section className="bg-roundone-dark-purple py-16 md:py-24">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl font-bold mb-6 text-white">Frequently Asked Questions</h1>
              <p className="text-lg text-roundone-white/80 mb-8">
                Find answers to common questions about RoundOne AI.
              </p>
            </div>
          </div>
        </section>

        {/* Replace FAQ content with the shared component */}
        <FrequentlyAskedQuestions />
        
        {/* Add ProvenResults component */}
        <ProvenResults />
      </main>
      
      {/* Use the shared Footer component */}
      <Footer />
    </div>
  );
};

export default FAQ;
